import { render, staticRenderFns } from "./ReviseResourceConfirm.vue?vue&type=template&id=40bcd444&"
import script from "./ReviseResourceConfirm.vue?vue&type=script&lang=ts&"
export * from "./ReviseResourceConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports